import { GoodRuleCard } from '@/pages/pii-training/GoodRuleCard';
import { HeadingBulletList } from '@/pages/pii-training/HeadingBulletList';
import type { ContentStepProps } from '@/pages/pii-training/piiTraining.types';
import { Stack } from '@careflux/primitives';

export const CombinationsStep = ({ copy }: ContentStepProps) => {
  const step = copy.combinations;

  return (
    <Stack as="section" gap="lg">
      <HeadingBulletList heading={step.combinationsHeading} items={step.combinationExamples} />
      <GoodRuleCard title={step.goodRuleTitle} body={step.goodRuleBody} />
    </Stack>
  );
};
